<div class="grid" *ngIf="carInformacionInicial; else contenido">
  <div class="col-12 md-12 lg-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>

<ng-template #contenido >
  <ng-container *ngIf="!banMensaje">
    <div class="container-title-solicitudes">
      <div class="titulo-endeudamiento">
        <p>{{ 'PERFILCREZCAMOS.LBL_SOLICITUDESVIGENTES' | translate}}</p>
      </div>
      <div class="contenedor-botones">
        <button class="boton-canceladas">
          <p>{{'PERFILCREZCAMOS.LBL_CANCELADAS' | translate}}</p>            
          <strong>{{ dataSolicitudes.cantidadCanceladas }}</strong>
        </button>
        <button class="boton-denegadas">
          <p>{{'PERFILCREZCAMOS.LBL_DENEGADAS' | translate}}</p>            
          <strong>{{ dataSolicitudes.cantidadDenegadas }}</strong>
        </button>
        <button class="boton-enproceso">
          <p>{{'PERFILCREZCAMOS.LBL_ENPROCESO' | translate}}</p>            
          <strong>{{ dataSolicitudes.cantidadEnProgreso }}</strong>
        </button>
      </div>
    </div>
    <ng-container *ngIf="listSolicitudes && listSolicitudes.length > 0">
      <p-table class="tabla-gris" [columns]="columnasSolicitudes" [value]="listSolicitudes" [paginator]="true"
              [rows]="10" [responsive]="true" paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
              <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
                <td class="text-center">{{  row.numeroCredito ?
                                            row.numeroCredito
                                            :row.idSolicitud ?
                                            row.idSolicitud
                                            : '-' }}</td>
                <td class="text-center">{{ row.estado ? row.estado : '-'}}</td>
                <td class="text-center">{{ row.oficina ? row.oficina : '-'}}</td>
                <td class="text-center">{{ row.fechaCreacion ?( row.fechaCreacion | date:'dd-MM-yyyy' ): '-'}}</td>
                <td class="text-center">{{ row.monto || row.monto === 0 ? ( formatCurrency( row.monto ) ) : '-'}}</td>
                <td class="text-center">{{ row.noCuotas || row.noCuotas === 0 ? row.noCuotas : '-'}}</td>
                <td class="text-center">{{ row.amortizacion ? row.amortizacion : '-'}}</td>
                <td class="text-center">{{ row.destino ? row.destino : '-'}}</td>
                <td class="text-center">{{ row.ejecutivo ? row.ejecutivo : '-'}}</td>
                <td class="text-center">
                  <div class="btn-group">
                    <div class="contador-firmantes">
                      <i class="fa fa-user-o" aria-hidden="true"></i>
                      {{ row.numeroFirmantes || row.numeroFirmantes === 0 ? row.numeroFirmantes : '-' }}
                    </div>
                    <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                            title="{{'BTN_VISUALIZAR' | translate}}" pButton (click)="visualizarFirmantes(row)">
                    </button>
                    <ng-container *ngIf="row.indicadorMenu">
                      <div
                        [hidden]="
                          validandoIndicador ||
                          (row.idProspecto
                            ? row.idProspecto == idRegistroCargandoItems
                            : row.idProceso
                            ? row.idProceso == idRegistroCargandoItems
                            : row.idSolicitud == idRegistroCargandoItems)
                        "
                      >
                        <div class="btn-group" role="group">
                          <button
                            type="button"
                            class="p-button btn"
                            icon="fa fa-cog"
                            data-toggle="tooltip"
                            title="{{ 'BTN_VERMAS' | translate }}"
                            pButton
                            (click)="obtenerItems(row, toggleMenu, $event)"
                          ></button>
      
                          <span
                            (click)="mostrarMensajeBloqueoSolicitudZona()"
                            *ngIf="row.indicadorRestringido"
                            style="
                              color: red;
                              margin-left: 10px;
                              cursor: pointer;
                            "
                          >
                            <i class="fa fa-lock fa-2x"></i>
                          </span>
                        </div>
                      </div>
                      <div
                        [hidden]="
                          !validandoIndicador &&
                          (row.idProspecto
                            ? row.idProspecto != idRegistroCargandoItems
                            : row.idProceso
                            ? row.idProceso != idRegistroCargandoItems
                            : row.idSolicitud != idRegistroCargandoItems)
                        "
                      >
                        <div class="grid">
                          <div
                            class="col-12 md-12 lg-12 text-center"
                          >
                            <i class="fa fa-refresh fa-spin fa-fw"></i>
                            <span
                              >{{ "LBL_VALIDANDO" | translate }}...</span
                            >
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td class="text-center" [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
            </tr>
          </ng-template>
      </p-table>
    </ng-container>
  <ng-container *ngIf="listSolicitudes && listSolicitudes.length === 0">
    <div class="no-hay-informacion">
      <label>{{'PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR' | translate}}</label>
    </div>
  </ng-container>
  </ng-container>
  <div class="no-hay-informacion" *ngIf="banMensaje">
    <label>{{'PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR' | translate}}</label>
  </div>
</ng-template>


<p-overlayPanel #toggleMenu styleClass="toggle-menu">
  <ng-template pTemplate="content">
    <ul *ngIf="lisItems.length > 0" class="list-menu">
      <li *ngFor="let i of lisItems" (click)="i.command()" class="item" [ngClass]="{'disabled-item': buscando || validandoIndicador}">
        <i class="fa {{ i.icon }}"></i> {{ i.label }}
      </li>
    </ul>
    <label *ngIf="lisItems.length === 0">{{ "LBL_SINACCIONES" | translate }}</label>
  </ng-template>
</p-overlayPanel>


<p-confirmDialog #cd key="cancelar">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<p-dialog
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [responsive]="true"
  [closeOnEscape]="false"
  [(visible)]="cambioEstado.mosModal"
  *ngIf="cambioEstado.mosModal"
  [contentStyle]="{ width: '600px' }"
  header="{{ datCambioEstado.titulo | translate }}"
  [modal]="true"
>
  <form
    [formGroup]="cambioEstado.formEstados"
    (ngSubmit)="cambiarEstado()"
    novalidate
  >
    <div class="grid form-group" *ngIf="datCambioEstado.verCausal">
      <div class="col-12 md-12 lg-12">
        <div class="div-form">
          <label>* {{ "FLUJOPROCESO.LBL_CAUSAL" | translate }}</label>
          <p-dropdown
            id="idCausal"
            name="nomCausal"
            [options]="cambioEstado.lisCausales"
            [filter]="true"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            *ngIf="!fEstados.causal.value"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"

            formControlName="idCausal"
          ></p-dropdown>
          <label class="falso-combo-texto" *ngIf="fEstados.causal.value">{{
            fEstados.causal.value
          }}</label>
          <div
            class="message p-messages-error p-corner-all"
            *ngIf="cambioEstado.submitted && fEstados.idCausal.invalid"
          >
            {{ "FLUJOPROCESO.LBL_CAUSAL" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md-12 lg-12">
        <div class="div-form">
          <label>{{ "FLUJOPROCESO.LBL_OBSERVACION" | translate }}</label>
          <textarea
            pInputTextarea
            type="text"
            id="idObservacion"
            name="nomObservacion"
            autocomplete="off"
            maxlength="500"
            formControlName="observacion"
            capitalize-reactive
          ></textarea>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!cambioEstado.guardando">
          <a (click)="cerrarModalEstados()" class="cancelar">{{
            "BTN_CANCELAR" | translate
          }}</a>
          <button
            icon="fa fa-floppy-o"
            label="{{ 'BTN_GUARDAR' | translate }}"
            type="submit"
            pButton
          ></button>
        </div>
        <div *ngIf="cambioEstado.guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_GUARDANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
